export const Types = {
  SET: '@issuer/SET',
};

type IssuerReturn = {
  type: string;
  name: string;
};

export function setIssuer(name: string): IssuerReturn {
  return {
    type: Types.SET,
    name,
  };
}
